
function initializeSwiper() {
  // Destroy any existing Swiper to prevent reinitialization errors
  const existingSwiper = document.querySelector('.related_product_slider')?.swiper;
  if (existingSwiper) {
    existingSwiper.destroy(true, true);
  }

  new Swiper('.related_product_slider', {
    slidesPerView: 5,
    centeredSlides: false,
    loop: false,
    slideToClickedSlide: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: "fraction",
    },
    breakpoints: {
      1024: { slidesPerView: 5, spaceBetween: 20 },
      750: { 
        slidesPerView: 2, 
        spaceBetween: 15, 
        pagination: {
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        }
      },
      640: { slidesPerView: 2, spaceBetween: 15 },
      420: { slidesPerView: 2, spaceBetween: 10 },
      380: { slidesPerView: 2, spaceBetween: 10 },
      364: { slidesPerView: 2, spaceBetween: 10 },
      340: { slidesPerView: 2, spaceBetween: 10 },
      320: { slidesPerView: 2, spaceBetween: 10 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Wait for product recommendations to load before initializing Swiper
  const observer = new MutationObserver((mutations, obs) => {
    const slider = document.querySelector('.related_product_slider.grid');
    if (slider && slider.querySelector('.swiper-slide')) {
      initializeSwiper();
      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback initialization (in case MutationObserver misses it)
  setTimeout(initializeSwiper, 300);
});
  

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 767) return;

  // Your function to apply hover effect
  function applyQuickAddHoverEffect() {
    const productCards = document.querySelectorAll(".custom-pdp");

    productCards.forEach((card) => {
      const quickAdd = card.querySelector(".quick-add");
      const gridItem = card.closest(".grid__item");

      card.addEventListener("mouseenter", function () {
        if (quickAdd) {
          const defaultHeight = card.scrollHeight;
          const quickAddHeight = quickAdd.scrollHeight;
          const newHeight = defaultHeight + quickAddHeight - 150;

          card.style.height = `${newHeight}px`;
          card.dataset.animationState = "open";
          if (card.dataset.animationState === "open" && gridItem) {
            gridItem.style.zIndex = "2";
          }
        }
      });

      card.addEventListener("mouseleave", function () {
        card.style.height = "auto";
        card.dataset.animationState = "closed";
        gridItem.style.zIndex = "";
      });
    });
  }

  // Run initially on page load
  applyQuickAddHoverEffect();

  // MutationObserver to catch dynamic product recommendations load
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelectorAll) {
            if (node.querySelector(".custom-pdp") || node.classList.contains("custom-pdp")) {
              applyQuickAddHoverEffect();
            }
          }
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});